import { render, staticRenderFns } from "./UserAccountDeleted.vue?vue&type=template&id=26a7c2fd&scoped=true&"
import script from "./UserAccountDeleted.vue?vue&type=script&lang=js&"
export * from "./UserAccountDeleted.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountDeleted.vue?vue&type=style&index=0&id=26a7c2fd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a7c2fd",
  null
  
)

export default component.exports